/* eslint-disable no-restricted-syntax */
//@ts-expect-error TODO: fix this
export function shallowDiffers(a, b) {
  if (!a || !b) return a !== b;
  // Reference: https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
  for (var i in a) if (!(i in b)) return true;
  for (var _i in b) if (a[_i] !== b[_i]) return true;
  return false;
}
export default shallowDiffers;